/**
 * Map a raw model ID (the value stored on `companies.ai_chat_model`
 * and returned on every agent response) to a Knowlez-branded tier
 * label. Provider identity is never surfaced to end users.
 */
const TIER_BY_ID: Record<string, string> = {
  'deepseek/deepseek-chat-v3.1': 'Knowlez Fast',
  'deepseek/deepseek-r1':         'Knowlez Reasoning · Fast',
  'anthropic/claude-sonnet-4.6':  'Knowlez Balanced',
  'anthropic/claude-opus-4.7':    'Knowlez Premium',
  'google/gemini-2.5-pro':        'Knowlez Multimodal',
  'openai/gpt-5':                 'Knowlez Frontier',
  'qwen/qwen3-coder-plus':        'Knowlez Code',
  'z-ai/glm-4.6':                 'Knowlez Lite',
};

const FALLBACK = 'Knowlez AI';

/** Friendly tier name for an agent response. Falls back to a generic label. */
export function modelTierLabel(modelId: string | null | undefined): string {
  if (!modelId) return FALLBACK;
  return TIER_BY_ID[modelId] ?? FALLBACK;
}
